import React, { useState } from 'react'
import CloseIcon from '../../../common/common-assets/icons/closeicon'
import {
  isConsumerOptedOut,
  setConsumerOptOut,
  clearConsumerOptOut,
  fireOptOutTracking,
} from '../../state/marketplaceAppOptOutActions'
import './consumerOptOutModal.scss'

function ConsumerOptOutModal(props) {
  const { closeModal } = props

  // The toggle reflects whether Advertising Retargeting Tracking is ON.
  // Opted out (cookie set) => tracking OFF => toggle starts off.
  const [trackingEnabled, setTrackingEnabled] = useState(
    () => !isConsumerOptedOut()
  )

  const handleConfirm = () => {
    if (!trackingEnabled) {
      // User wants to opt OUT.
      if (isConsumerOptedOut()) {
        // Already opted out, nothing changed, just close.
        closeModal()
      } else {
        setConsumerOptOut()
        // Hit the conversion endpoint, then refresh once it has fired.
        fireOptOutTracking(() => window.location.reload())
      }
    } else {
      // Toggle is ON, so the user wants tracking (opt back in).
      if (isConsumerOptedOut()) {
        clearConsumerOptOut()
        window.location.reload()
      } else {
        closeModal()
      }
    }
  }

  const handleAllowAll = () => {
    if (isConsumerOptedOut()) {
      clearConsumerOptOut()
      window.location.reload()
    } else {
      // Nothing was opted out, so no need to reload.
      closeModal()
    }
  }

  return (
    <div className="consumer-opt-out-modal-container">
      <div className="close-modal" onClick={() => closeModal()}>
        <CloseIcon />
      </div>

      <h2 className="consumer-opt-out-title">Privacy Settings</h2>

      <p className="consumer-opt-out-copy">
        We use tracking technologies to run our site, improve performance, and
        understand usage. Some tracking technologies are essential; others
        support advertising retargeting. You can opt out advertising retargeting
        tracking below. By continuing to use our site, you agree to our{' '}
        <a href="https://www.ipacket.us/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        .
      </p>

      <div className="consumer-opt-out-toggle-row">
        <span className="consumer-opt-out-toggle-label">
          Advertising Retargeting Tracking
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={trackingEnabled}
          className={`consumer-opt-out-toggle${
            trackingEnabled ? ' is-on' : ''
          }`}
          onClick={() => setTrackingEnabled((prev) => !prev)}
        >
          <span className="consumer-opt-out-toggle-knob" />
        </button>
      </div>

      <div className="consumer-opt-out-actions">
        <button
          type="button"
          className="consumer-opt-out-btn confirm"
          onClick={handleConfirm}
        >
          Confirm My Choices
        </button>
        <button
          type="button"
          className="consumer-opt-out-btn allow-all"
          onClick={handleAllowAll}
        >
          Allow All
        </button>
      </div>
    </div>
  )
}

export default ConsumerOptOutModal
